import apiClient from "QueryClient/axiosClient";

export const createProfile = async (data) => {
  return apiClient.put(`/oneGradRep/create`, data);
};

export const generateSummary = async (data) => {
  return apiClient.post(`/oneGradRep/generateSummary`, data);
};
